// @flow
import * as React from 'react';
import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const PageTitle = (props: PropsWithChildren<{title: string}>) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={3}>
      <Typography variant={'subtitle1'} sx={{fontWeight: 500, '&': { fontSize: 20 }}}>{props.title}</Typography>
      {props.children}
    </Stack>
  );
};
